var _line, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLandingLineSvg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 1,
    viewBox: "0 0 112 1",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: -4.37114e-8,
    y1: 0.5,
    x2: 112,
    y2: 0.49999,
    stroke: "url(#paint0_linear_504_5961)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_504_5961",
    x1: -0.00000218749,
    y1: 1.16667,
    x2: 3.40279,
    y2: 20.8111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA905C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33187,
    stopColor: "#FFD29B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.472229,
    stopColor: "#FFE0B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.612142,
    stopColor: "#FFD29B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994792,
    stopColor: "#BA905C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandingLineSvg);
export default __webpack_public_path__ + "static/media/LandingLineSVG.395c33b338d14a5a3777e3477cc029b7.svg";
export { ForwardRef as ReactComponent };